module.exports = __webpack_public_path__ + "img/5.31cf23d7.jpg";